import { haveFilterQuery, paginator, haveSort } from '../../common/auxFun'

const endpointsPurchasesSummary = {
  LOAD: (
    filter,
    sort,
    limit,
    skip,
    dateFrom,
    dateTo,
    ownStation,
    supplier,
    isTotal,
  ) =>
    `/v1/purchases/summary${haveFilterQuery(filter)}${
      dateFrom ? `&dateFrom=${dateFrom}` : ''
    }${dateTo ? `&dateTo=${dateTo}` : ''}${
      ownStation ? `&ownStation=${ownStation}` : ''
    }${supplier ? `&supplier=${supplier}` : ''}${
      isTotal ? `&isTotal=${isTotal}` : ''
    }${paginator(limit, skip)}${haveSort(sort)}`,
}

export default endpointsPurchasesSummary
